import { useMaintenanceMode } from '../hooks/useMaintenanceMode';
import { MaintenancePage } from '../pages/MaintenancePage';
import { useAuth } from '../providers/AuthProvider';

import { EkranStartuPowloki } from './ProtectedRoute';

/**
 * Maintenance gate for routes mounted OUTSIDE ProtectedRoute — the PIN/anon
 * shop-floor surfaces (/mobile/*, /m/*, /mobile/lexshift, /kiosk/lexshift).
 * While the global maintenance flag is on, everyone except a super-admin (who
 * could be signed in via the shell) sees the MaintenancePage. ProtectedRoute
 * applies the same rule to the authenticated web panels.
 */
export function MaintenanceGate({ children }: { children: React.ReactNode }) {
  const { maintenanceMode, isLoading } = useMaintenanceMode();
  const { canAccessPanel } = useAuth();

  // Ten sam ekran startu, co w ProtectedRoute i we wstawce `index.html` —
  // terminal na hali też startuje jednym obrazem.
  if (isLoading) {
    return <EkranStartuPowloki />;
  }

  if (maintenanceMode && !canAccessPanel('super-admin')) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
}
